import { Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';

@Injectable()
export class YesNoPresetProvider implements FormlyFieldConfigPresetProvider {
  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'button',
      props: {
        options: [
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ],
      },
    };
  }
}

export function registerYesNoPreset(): ConfigOption {
  return { presets: [{ name: 'yesNo', config: new YesNoPresetProvider() }] };
}
